export class CustomHtmlAttributes {
    sectionHeading: string;
    sectionSubHeading: string;
    htmlContent: string;
}
